var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarArrow4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.35205 6.39795L7.10205 10.1479C7.20772 10.2536 7.35105 10.313 7.50049 10.313C7.64993 10.313 7.79325 10.2536 7.89893 10.1479C8.0046 10.0423 8.06396 9.89895 8.06396 9.74951C8.06396 9.60007 8.0046 9.45675 7.89893 9.35107L4.5469 5.99998L7.89799 2.64795C7.95031 2.59562 7.99182 2.53351 8.02014 2.46514C8.04845 2.39678 8.06303 2.32351 8.06303 2.24951C8.06303 2.17551 8.04845 2.10224 8.02014 2.03388C7.99182 1.96551 7.95031 1.9034 7.89799 1.85107C7.84567 1.79875 7.78355 1.75724 7.71518 1.72893C7.64682 1.70061 7.57355 1.68604 7.49955 1.68604C7.42555 1.68604 7.35228 1.70061 7.28392 1.72893C7.21555 1.75724 7.15344 1.79875 7.10111 1.85107L3.35111 5.60107C3.29874 5.65339 3.2572 5.71554 3.22889 5.78394C3.20058 5.85235 3.18605 5.92567 3.18614 5.99971C3.18623 6.07374 3.20093 6.14703 3.2294 6.21537C3.25787 6.2837 3.29955 6.34575 3.35205 6.39795Z",
    fill: "#6B5CE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarArrow4);
export default __webpack_public_path__ + "static/media/dar_arrow4.2d8f1f3c373e9a084780dac0c3841165.svg";
export { ForwardRef as ReactComponent };